 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activate-btc":"activate-btc","activate-polygon":"activate-polygon","add-account":"add-account","add-vesting-contract":"add-vesting-contract","cashlink":"cashlink","change-password":"change-password","checkout":"checkout","choose-address~connect-account":"choose-address~connect-account","choose-address":"choose-address","connect-account":"connect-account","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90","activate-btc-ledger":"activate-btc-ledger","add-ledger":"add-ledger","refund-swap-ledger~swap~swap-ledger":"refund-swap-ledger~swap~swap-ledger","refund-swap-ledger":"refund-swap-ledger","swap~swap-ledger":"swap~swap-ledger","swap-ledger":"swap-ledger","sign-btc-transaction-ledger":"sign-btc-transaction-ledger","sign-message-ledger":"sign-message-ledger","sign-transaction-ledger":"sign-transaction-ledger","electrum-client":"electrum-client","common":"common","cookie-decoder":"cookie-decoder","export":"export","lang-de-po":"lang-de-po","lang-en-po":"lang-en-po","lang-es-po":"lang-es-po","lang-fil-po":"lang-fil-po","lang-fr-po":"lang-fr-po","lang-nl-po":"lang-nl-po","lang-pt-po":"lang-pt-po","lang-ru-po":"lang-ru-po","lang-tr-po":"lang-tr-po","lang-uk-po":"lang-uk-po","lang-zh-po":"lang-zh-po","logout":"logout","logout-ledger":"logout-ledger","migrate":"migrate","onboarding":"onboarding","swap":"swap","rename":"rename","request-error":"request-error","sign-btc-transaction":"sign-btc-transaction","sign-message":"sign-message","sign-multisig-transaction":"sign-multisig-transaction","sign-polygon-transaction":"sign-polygon-transaction","sign-staking":"sign-staking","sign-transaction":"sign-transaction","unsupported-ledger":"unsupported-ledger"}[chunkId]||chunkId) + "-legacy." + {"activate-btc":"e01987d1","activate-polygon":"2fb60ca7","add-account":"9c042434","add-vesting-contract":"3882e984","cashlink":"d5c6bff9","change-password":"d3b8698a","checkout":"39a27486","choose-address~connect-account":"67db82db","choose-address":"7a5e49c3","connect-account":"0c78c4ed","chunk-0ff83732":"3dd1960f","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"42710750","activate-btc-ledger":"c7c00718","add-ledger":"8825f70c","refund-swap-ledger~swap~swap-ledger":"cfab32d7","refund-swap-ledger":"34e7fc73","swap~swap-ledger":"128c8007","swap-ledger":"d0d285e7","sign-btc-transaction-ledger":"2cd2f90a","sign-message-ledger":"adb48b92","sign-transaction-ledger":"af4e37d9","chunk-2d0b1fa8":"3b499fb1","chunk-2d237ef5":"ea9107d9","chunk-5cf8ec01":"5e280ee7","chunk-412aa1ee":"f1e9ddd4","chunk-42f071ba":"2881ae43","electrum-client":"93b4e270","chunk-5162c944":"10ed405f","common":"b7a37dfb","cookie-decoder":"bd8d3286","export":"a2b7a54f","lang-de-po":"b7bbe6b7","lang-en-po":"b8f425fb","lang-es-po":"40d726e7","lang-fil-po":"1b3380ca","lang-fr-po":"27700881","lang-nl-po":"9d6b3f18","lang-pt-po":"7c50b2e5","lang-ru-po":"afd9df63","lang-tr-po":"f61108f4","lang-uk-po":"890527b7","lang-zh-po":"aab70fd8","logout":"420d6e7b","logout-ledger":"c2a342d5","migrate":"f90394ff","onboarding":"5a4b95d8","swap":"bce4a8d5","rename":"12e8a2b9","request-error":"e8dbd6a8","sign-btc-transaction":"666b8131","sign-message":"3631b1b1","sign-multisig-transaction":"04946f58","sign-polygon-transaction":"0f0d7040","sign-staking":"b9c2c6d6","sign-transaction":"0c280fa0","unsupported-ledger":"41555343","chunk-06a7c5c4":"577520bf","chunk-2d0aecce":"676063ce","chunk-3828fb5f":"97d17923","chunk-4b9ba3fe":"167c2eb8","chunk-0bb4379c":"13d269aa","chunk-2d0e4c71":"72a52202","chunk-2d0e667a":"8db85252","chunk-42292633":"dd49b417","chunk-5863784e":"9c0ba287","chunk-74672b86":"93a646fe","chunk-7de0b880":"449bb722","chunk-a0cd5dd0":"426aaaea","chunk-a0f5d4d0":"73d49ca8","chunk-a0f5dbe6":"cbeb44f1","chunk-a0f88cce":"8daf0b1f","chunk-a0f90098":"3867fce2","chunk-b16e53e0":"b8a7c77a","chunk-d2cac50e":"adb4be6f","chunk-8724e426":"519815aa","chunk-4142fd92":"35fe6654","chunk-361dc9c6":"96df6e7c","chunk-522442ab":"31b017a6","chunk-6664cac8":"8904a3d3","chunk-56f95169":"21a20ad1","chunk-2af39605":"6eadb4ea","chunk-2d216055":"f5aa254b","chunk-2c17f7a7":"dbc13280","chunk-b15e8a52":"7be134d3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activate-btc":1,"activate-polygon":1,"add-account":1,"add-vesting-contract":1,"cashlink":1,"checkout":1,"choose-address~connect-account":1,"choose-address":1,"connect-account":1,"activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":1,"add-ledger":1,"refund-swap-ledger":1,"swap-ledger":1,"sign-btc-transaction-ledger":1,"sign-message-ledger":1,"sign-transaction-ledger":1,"common":1,"export":1,"logout":1,"logout-ledger":1,"migrate":1,"onboarding":1,"swap":1,"rename":1,"request-error":1,"sign-btc-transaction":1,"sign-message":1,"sign-multisig-transaction":1,"unsupported-ledger":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activate-btc":"activate-btc","activate-polygon":"activate-polygon","add-account":"add-account","add-vesting-contract":"add-vesting-contract","cashlink":"cashlink","change-password":"change-password","checkout":"checkout","choose-address~connect-account":"choose-address~connect-account","choose-address":"choose-address","connect-account":"connect-account","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90","activate-btc-ledger":"activate-btc-ledger","add-ledger":"add-ledger","refund-swap-ledger~swap~swap-ledger":"refund-swap-ledger~swap~swap-ledger","refund-swap-ledger":"refund-swap-ledger","swap~swap-ledger":"swap~swap-ledger","swap-ledger":"swap-ledger","sign-btc-transaction-ledger":"sign-btc-transaction-ledger","sign-message-ledger":"sign-message-ledger","sign-transaction-ledger":"sign-transaction-ledger","electrum-client":"electrum-client","common":"common","cookie-decoder":"cookie-decoder","export":"export","lang-de-po":"lang-de-po","lang-en-po":"lang-en-po","lang-es-po":"lang-es-po","lang-fil-po":"lang-fil-po","lang-fr-po":"lang-fr-po","lang-nl-po":"lang-nl-po","lang-pt-po":"lang-pt-po","lang-ru-po":"lang-ru-po","lang-tr-po":"lang-tr-po","lang-uk-po":"lang-uk-po","lang-zh-po":"lang-zh-po","logout":"logout","logout-ledger":"logout-ledger","migrate":"migrate","onboarding":"onboarding","swap":"swap","rename":"rename","request-error":"request-error","sign-btc-transaction":"sign-btc-transaction","sign-message":"sign-message","sign-multisig-transaction":"sign-multisig-transaction","sign-polygon-transaction":"sign-polygon-transaction","sign-staking":"sign-staking","sign-transaction":"sign-transaction","unsupported-ledger":"unsupported-ledger"}[chunkId]||chunkId) + "." + {"activate-btc":"a9060c70","activate-polygon":"a9060c70","add-account":"e8f97a43","add-vesting-contract":"9d5afa69","cashlink":"8c409bbe","change-password":"d41d8cd9","checkout":"733dd733","choose-address~connect-account":"a9060c70","choose-address":"942d1018","connect-account":"fc23208b","chunk-0ff83732":"d41d8cd9","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"452d58d3","activate-btc-ledger":"d41d8cd9","add-ledger":"da0749af","refund-swap-ledger~swap~swap-ledger":"d41d8cd9","refund-swap-ledger":"d691255b","swap~swap-ledger":"d41d8cd9","swap-ledger":"8dacd8db","sign-btc-transaction-ledger":"f068edc9","sign-message-ledger":"994b64c6","sign-transaction-ledger":"841bc4ad","chunk-2d0b1fa8":"d41d8cd9","chunk-2d237ef5":"d41d8cd9","chunk-5cf8ec01":"d41d8cd9","chunk-412aa1ee":"d41d8cd9","chunk-42f071ba":"d41d8cd9","electrum-client":"d41d8cd9","chunk-5162c944":"d41d8cd9","common":"71d2c8d0","cookie-decoder":"d41d8cd9","export":"71d2c8d0","lang-de-po":"d41d8cd9","lang-en-po":"d41d8cd9","lang-es-po":"d41d8cd9","lang-fil-po":"d41d8cd9","lang-fr-po":"d41d8cd9","lang-nl-po":"d41d8cd9","lang-pt-po":"d41d8cd9","lang-ru-po":"d41d8cd9","lang-tr-po":"d41d8cd9","lang-uk-po":"d41d8cd9","lang-zh-po":"d41d8cd9","logout":"71d2c8d0","logout-ledger":"4af0f788","migrate":"ce303082","onboarding":"1ac2fc69","swap":"a9060c70","rename":"b4fdafca","request-error":"71d2c8d0","sign-btc-transaction":"a9060c70","sign-message":"fc19f920","sign-multisig-transaction":"71d2c8d0","sign-polygon-transaction":"d41d8cd9","sign-staking":"d41d8cd9","sign-transaction":"d41d8cd9","unsupported-ledger":"a9060c70","chunk-06a7c5c4":"d41d8cd9","chunk-2d0aecce":"d41d8cd9","chunk-3828fb5f":"d41d8cd9","chunk-4b9ba3fe":"d41d8cd9","chunk-0bb4379c":"d41d8cd9","chunk-2d0e4c71":"d41d8cd9","chunk-2d0e667a":"d41d8cd9","chunk-42292633":"d41d8cd9","chunk-5863784e":"d41d8cd9","chunk-74672b86":"d41d8cd9","chunk-7de0b880":"d41d8cd9","chunk-a0cd5dd0":"d41d8cd9","chunk-a0f5d4d0":"d41d8cd9","chunk-a0f5dbe6":"d41d8cd9","chunk-a0f88cce":"d41d8cd9","chunk-a0f90098":"d41d8cd9","chunk-b16e53e0":"d41d8cd9","chunk-d2cac50e":"d41d8cd9","chunk-8724e426":"d41d8cd9","chunk-4142fd92":"d41d8cd9","chunk-361dc9c6":"d41d8cd9","chunk-522442ab":"d41d8cd9","chunk-6664cac8":"d41d8cd9","chunk-56f95169":"d41d8cd9","chunk-2af39605":"d41d8cd9","chunk-2d216055":"d41d8cd9","chunk-2c17f7a7":"d41d8cd9","chunk-b15e8a52":"d41d8cd9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
 					linkTag.crossOrigin = "anonymous";
 				}
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
